/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/ui/formlabel/formlabel.component.css.shim.ngstyle.js.pre-build-optimizer.js